import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import cx from 'classnames'
import _ from 'lodash'

import { FormattedMessage } from 'react-intl'

import Indicators from '../../Indicators'

import BisnodeScoringTooltip from '../../../../../../../../../components/Tooltips/Indicators/BisnodeScoringTooltip'
import DebtsTooltip from '../../../../../../../../../components/Tooltips/Indicators/DebtsTooltip'
import DistraintsTooltip from '../../../../../../../../../components/Tooltips/Indicators/DistraintsTooltip'
import InsolvencyTooltip from '../../../../../../../../../components/Tooltips/Indicators/InsolvencyTooltip'
import LiquidationTooltip from '../../../../../../../../../components/Tooltips/Indicators/LiquidationTooltip'
import PaymentIndexTooltip from '../../../../../../../../../components/Tooltips/Indicators/PaymentIndexTooltip'
import VatTooltip from '../../../../../../../../../components/Tooltips/Indicators/VatTooltip'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'

@hocBlock(config.modules.report.key, { levelReload: true })
@hocConnect
export default class BasicInformation extends Component {
    static propTypes = {
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        ribbonBlocks: IPropTypes.map,
        scrollRefs: PropTypes.object,
        scrollTo: PropTypes.func.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true

        return false
    }

    indicatorClickHandler = (identifier) => {
        const { scrollRefs, scrollTo, ribbonBlocks } = this.props

        if (scrollRefs[identifier] && ribbonBlocks.get(identifier)) scrollTo(scrollRefs[identifier])
    }

    render() {
        const { data, scrollRefs, level } = this.props

        return (
            <div className={cx('block-indicators')}>
                <Indicators
                    data={data}
                    onClickHandler={this.indicatorClickHandler}
                    scrollRefs={scrollRefs}
                    level={level}
                    translates={{
                        bisnodeScoringTitle: <FormattedMessage id={`${LOCALE_PREFIX}.bisnodeScoringTitle`} />,
                        bisnodeScoringTootlip: <BisnodeScoringTooltip />,
                        debtsTitle: <FormattedMessage id={`${LOCALE_PREFIX}.debtsTitle`} />,
                        debtsTooltip: <DebtsTooltip />,
                        distraintsTitle: <FormattedMessage id={`${LOCALE_PREFIX}.distraintsTitle`} />,
                        distraintsTooltip: <DistraintsTooltip />,
                        insolvencyTitle: <FormattedMessage id={`${LOCALE_PREFIX}.insolvencyTitle`} />,
                        insolvencyTooltip: <InsolvencyTooltip />,
                        liquidationTitle: <FormattedMessage id={`${LOCALE_PREFIX}.liquidationTitle`} />,
                        liquidationTooltip: <LiquidationTooltip />,
                        paymentIndexTitle: <FormattedMessage id={`${LOCALE_PREFIX}.paymentIndexTitle`} />,
                        paymentIndexTooltip: <PaymentIndexTooltip />,
                        vatTitle: <FormattedMessage id={`${LOCALE_PREFIX}.vatTitle`} />,
                        vatTooltip: <VatTooltip />,
                        noMessage: <FormattedMessage id={`${LOCALE_PREFIX}.no`} />,
                        activeMessage: <FormattedMessage id={`${LOCALE_PREFIX}.activeMessage`} />,
                        historicalMessage: <FormattedMessage id={`${LOCALE_PREFIX}.historicalMessage`} />,
                        naDescription: <FormattedMessage id={`${LOCALE_PREFIX}.naDescription`} />,
                    }}
                />
            </div>
        )
    }
}
